import {formatter, request} from '@/utils/request';

export namespace ProductAndIp {
  export const Path = {
    get: '/expenseapi/productAndIp/get',
    getByProductIds: '/expenseapi/productAndIp/getByProductIds',
  };

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id
      },
    };
    return request<API.ResponseResult<API.ProductAndIp>>(Path.get, formatter(options));
  }

  export async function getByProductIds(productIds: string) {
    const options = {
      method: 'GET',
      body: {
        productIds
      },
    };
    return request<API.ResponseResult<API.ProductAndIp[]>>(Path.getByProductIds, formatter(options));
  }
}
